import * as React from "react";
import { Route, Switch, useRouteMatch } from "react-router";

import { SuiviApprenantWalterDetailPage } from "./SuiviApprenantWalterDetailPage";
import { SuiviApprenantSearchPage } from "./SuiviApprenantSearchPage";

interface ISuiviApprenantProspectProps {
  baseRoute: string;
}

export const SuiviApprenantProspect: React.FunctionComponent<ISuiviApprenantProspectProps> = ({ baseRoute }) => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route path={`${match.path}`} exact>
        <SuiviApprenantSearchPage baseRoute={baseRoute} />
      </Route>
      <Route path={`${match.path}/:idSuivi/:state/walter`} exact>
        <SuiviApprenantWalterDetailPage baseRoute={baseRoute} />
      </Route>
      <Route path={`${match.path}/:idSuivi/:state`} exact>
        <SuiviApprenantWalterDetailPage baseRoute={baseRoute} />
      </Route>
    </Switch>
  );
};
